<template>
<div :class="`a-dotted-line${fullWidth ? ' full-width': ''}`">
	<div class="dotted-line"></div>
	</div>
</template>
<script>
export default {
	props: {
		fullWidth: {
			type: Boolean,
			default: false
		}
	}
}
</script>
<style lang="scss" scoped>
.a-dotted-line {
	max-width: 1580px;
	height: 2px;
	width: 100%;
	margin: auto;
	padding: 20px 100px;
	@media(max-width: 800px) {
		padding: 20px;
	}
}
.full-width {
	margin: 0;
	width: auto;
	padding: 0;
}
.dotted-line {
	background-image: url(../assets/images/gray-oval.svg);
	background-repeat: space;
	background-size: 10px;
	height: 2px;

}

</style>
